import { render } from "./TransactionPackage.vue?vue&type=template&id=c96238ec&scoped=true"
import script from "./TransactionPackage.vue?vue&type=script&lang=js"
export * from "./TransactionPackage.vue?vue&type=script&lang=js"

import "./TransactionPackage.vue?vue&type=style&index=0&id=c96238ec&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96238ec"]])

export default __exports__